module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/headquarters/hq-grid-2-large-af550a6e9b08d2d6c28311eea2e0c8b4.jpg";